if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        if (!this.elements.input || !this.elements.button || !this.elements.panel) return;

        this.menuDrawer = document.querySelector('.menu-drawer');
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        if (this.elements.input.name === 'locale_code') {
          this.updateLanguageLinks();
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      getLanguageUrl(localizationUrl) {
        if (!localizationUrl || !window.location.search) return localizationUrl;

        const url = new URL(localizationUrl, window.location.origin);
        const currentSearchParams = new URLSearchParams(window.location.search);

        currentSearchParams.forEach((value, key) => {
          if (!url.searchParams.has(key)) {
            url.searchParams.append(key, value);
          }
        });

        return `${url.pathname}${url.search}${url.hash}`;
      }

      updateLanguageLinks() {
        this.querySelectorAll('a[data-localization-url]').forEach((link) => {
          const localizationUrl = this.getLanguageUrl(link.dataset.localizationUrl);
          link.dataset.localizationUrl = localizationUrl;
          link.href = localizationUrl;
        });
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        if (this.menuDrawer) this.menuDrawer.classList.remove('country-selector-open');
        if (this.header) this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const target = event.currentTarget;
        const localizationUrl = target.dataset.localizationUrl;
        const form = this.querySelector('form');
        this.elements.input.value = target.dataset.value;
        if (this.elements.input.name === 'locale_code' && localizationUrl) {
          window.location.href = localizationUrl;
          return;
        }
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          if (this.header) this.header.preventHide = true;
        }
        if (this.menuDrawer) this.menuDrawer.classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}

(function () {
  const productPathPattern = /\/products\/paper_tracker-face-eye-tracking-kit\/?$/;
  const legacyNoticePattern = /Fast Shipping, VAT|1-Year Warranty Included|VAT and import duties/i;

  const copy = {
    en: {
      eyebrow: 'Batch notice',
      title: 'First international early-bird batch notice',
      paragraphs: [
        "Please read this notice before ordering. The current batch is Paper_Tracker's first early-bird batch opened to international buyers, offered at a lower price than the later full international batch.",
        'This batch is not the same as a complete retail batch: shipping, import duties, VAT/GST, local taxes, and customs clearance fees are separate; packaging, certification marks, and some included materials are mainly based on the Chinese mainland version; English manuals and international support materials are still being added. Later batches may upgrade hardware or accessories. If you want a lower-friction regular retail experience, we do not recommend buying the current early-bird batch.',
      ],
      button: 'Read the full notice',
    },
    ja: {
      eyebrow: 'バッチ通知',
      title: '初回国際アーリーバードバッチ通知',
      paragraphs: [
        'ご注文前に本通知をご確認ください。現在のバッチは Paper_Tracker を国際ユーザー向けに初めて提供するアーリーバードバッチで、後続の正式国際バッチより低い価格です。',
        '本バッチは、完成された通常小売バッチとは異なります。国際送料、輸入関税、VAT/GST、現地税、通関費用は別途必要です。包装、認証表示、一部同梱情報は主に中国本土版をベースにしており、英語マニュアルや国際向けサポート情報は順次追加します。後続バッチではハードウェアやアクセサリーがアップグレードされる可能性があります。通常の小売体験を希望される場合は、現在のアーリーバードバッチの購入はおすすめしません。',
      ],
      button: '通知全文を読む',
    },
    ko: {
      eyebrow: '배치 공지',
      title: '첫 국제 얼리버드 배치 공지',
      paragraphs: [
        '주문 전에 본 공지를 확인해 주세요. 현재 배치는 Paper_Tracker를 국제 사용자에게 처음 제공하는 얼리버드 배치이며, 이후 정식 국제 배치보다 낮은 가격입니다.',
        '이 배치는 완성된 일반 소매 배치와 동일하지 않습니다. 국제 배송비, 수입 관세, VAT/GST, 현지 세금, 통관 비용은 별도로 부담해야 합니다. 포장, 인증 표시, 일부 동봉 정보는 주로 중국 본토 버전을 기반으로 하며, 영문 설명서와 국제 지원 자료는 순차적으로 보완됩니다. 이후 배치에서는 하드웨어나 액세서리가 업그레이드될 수 있습니다. 더 간편한 일반 소매 경험을 원한다면 현재 얼리버드 배치 구매를 권장하지 않습니다.',
      ],
      button: '전체 공지 보기',
    },
    zh: {
      eyebrow: '批次通知',
      title: '首批国际早鸟批次通知',
      paragraphs: [
        '请在下单前阅读本通知。当前批次为 Paper_Tracker 面向国际用户开放的首批早鸟批次，价格低于后续正式国际批次。',
        '本批次不等同于完整普通零售批次：运费、进口关税、VAT/GST、本地税费和清关费用需另行承担；包装、认证标识和部分随附信息主要沿用中国大陆版本；英文说明书和国际支持内容会陆续补齐。后续批次可能升级硬件或配件。若你希望获得更省心的普通零售体验，我们不建议购买当前早鸟批次。',
      ],
      button: '阅读完整通知',
    },
  };

  function currentCopy() {
    const lang = document.documentElement.lang.toLowerCase();
    if (lang.startsWith('ja')) return copy.ja;
    if (lang.startsWith('ko')) return copy.ko;
    if (lang.startsWith('zh')) return copy.zh;
    return copy.en;
  }

  function detailsUrl() {
    const firstPathSegment = window.location.pathname.split('/').filter(Boolean)[0];
    const localizedRoot = ['en', 'ja', 'ko'].includes(firstPathSegment) ? `/${firstPathSegment}/` : '/';
    return `${localizedRoot}pages/international-early-bird-batch`;
  }

  function injectNoticeStyles() {
    if (document.getElementById('pt-early-bird-notice-client-style')) return;

    const style = document.createElement('style');
    style.id = 'pt-early-bird-notice-client-style';
    style.textContent = `
      .pt-early-bird-notice-section { padding-block: 36px; }
      .pt-early-bird-notice { display: grid; grid-template-columns: minmax(0, 1fr) auto; gap: 2.4rem; align-items: center; padding: 2.4rem; border: 1px solid rgba(180, 83, 9, 0.28); border-left: 0.6rem solid #d97706; border-radius: 8px; background: #fff7ed; color: #231f20; overflow-wrap: anywhere; }
      .pt-early-bird-notice__content { max-width: 96rem; }
      .pt-early-bird-notice__eyebrow { margin: 0 0 0.8rem; color: #9a3412; font-size: 1.2rem; font-weight: 700; letter-spacing: 0; text-transform: uppercase; }
      .pt-early-bird-notice__title { margin: 0 0 0.8rem; color: #111827; font-size: clamp(2rem, 2.2vw, 2.8rem); line-height: 1.2; letter-spacing: 0; }
      .pt-early-bird-notice__body { max-width: 88rem; color: #3f3f46; font-size: 1.5rem; line-height: 1.65; }
      .pt-early-bird-notice__body p { margin-block: 0; }
      .pt-early-bird-notice__body p + p { margin-top: 0.8rem; }
      .pt-early-bird-notice__button { white-space: normal; text-align: center; }
      @media screen and (max-width: 749px) {
        .pt-early-bird-notice { grid-template-columns: 1fr; gap: 1.8rem; padding: 2rem; }
        .pt-early-bird-notice__button { width: 100%; }
      }
    `;
    document.head.appendChild(style);
  }

  function replaceLegacyNotice() {
    if (!productPathPattern.test(window.location.pathname)) return;

    const section = document.querySelector('section[id$="__multicolumn_eaiCJ6"]');
    if (!section || section.querySelector('.pt-early-bird-notice')) return;
    if (!legacyNoticePattern.test(section.textContent || '')) return;

    const noticeCopy = currentCopy();
    injectNoticeStyles();

    section.innerHTML = `
      <section class="pt-early-bird-notice-section">
        <div class="page-width">
          <div class="pt-early-bird-notice">
            <div class="pt-early-bird-notice__content">
              <p class="pt-early-bird-notice__eyebrow">${noticeCopy.eyebrow}</p>
              <h2 class="pt-early-bird-notice__title">${noticeCopy.title}</h2>
              <div class="pt-early-bird-notice__body rte">
                ${noticeCopy.paragraphs.map((paragraph) => `<p>${paragraph}</p>`).join('')}
              </div>
            </div>
            <a class="button button--primary pt-early-bird-notice__button" href="${detailsUrl()}">
              ${noticeCopy.button}
            </a>
          </div>
        </div>
      </section>
    `;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceLegacyNotice);
  } else {
    replaceLegacyNotice();
  }
})();
